<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title>
      <!-- <b [ngStyle]="{color: this.frmHealthInformation.errors?.['required'] ? 'red': ''}" class="disable_ripple_font"> </b>         -->
      <div *ngIf="this.frmHealthInformation.errors?.['required']==null">
        <b>HEALTH INFORMATION </b>
		<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_HealthInformation_Overview'"></help-text-btn>
      </div>
      <div *ngIf="this.frmHealthInformation.errors?.['required']">
        <b style="color: red;">HEALTH INFORMATION (incomplete)</b>
      </div>

    </mat-panel-title>

  </mat-expansion-panel-header>

  <form [formGroup]="frmHealthInformation">
    <!-- Health Insurance-->
    <div class="row">
      <div class="col-3">
        <mat-label><b>Health Insurance? </b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_HealthInformation_HealthInsurance'"></help-text-btn>
        </mat-label>
      </div>
      <div class="col-3">
        <mat-radio-group aria-label name="radioHealthInsurance" formControlName="radioHealthInsurance"
          id="radioHealthInsurance" [color]="'primary'">
          <mat-radio-button value="1">Yes</mat-radio-button>
          <mat-radio-button value="2">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="col-3">
        <p>
          <mat-checkbox [color]="'primary'" formControlName="mediCal">Medi-Cal</mat-checkbox>
        </p>
      </div>
    </div>

    <!-- Health Concern-->
    <div class="row">
      <div class="col-3">
        <mat-label><b>Health Concerns? </b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_HealthInformation_HealthConcerns'"></help-text-btn>
        </mat-label>
      </div>
      <div class="col-3">
        <mat-radio-group aria-label name="radioHealConcern" formControlName="radioHealConcern" id="radioHealConcern"
          [color]="'primary'">
          <mat-radio-button class="example-radio-button" value="1">Yes</mat-radio-button>
          <mat-radio-button class="example-radio-button" value="2">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="col-3">
        <p>
          <mat-checkbox [color]="'primary'" formControlName="currentlyTreatment">Currently in Treatment</mat-checkbox>
        </p>
      </div>
    </div>

    <!--Health Needs-->
    <div class="row" style="padding-top: 30px"></div>
    <mat-divider></mat-divider>

    <div class="row" style="padding-top: 30px">
      <div class="col-3">
        <mat-label>
          <b [ngStyle]="{color: this.frmHealthInformation.errors?.['required'] ? 'red': ''}"
            class="disable_ripple_font">Health Needs *
          </b>
		  <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_HealthInformation_HealthNeeds'"></help-text-btn>
        </mat-label>
      </div>
      <div class="col-3">
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="medical">Medical</mat-checkbox>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="dental">Dental</mat-checkbox>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="vision">Vision</mat-checkbox>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="mentalHealth">Mental Health</mat-checkbox>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="chkHealthOther">Other</mat-checkbox>
        </div>
        <div class="row">
          <mat-form-field class="nowrapper" appearance="outline">
            <mat-label>Comments</mat-label>
            <input matInput type="text" formControlName="txtHealthOther" (focusout)="updateChangeValueLostFocus()" />
          </mat-form-field>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="healthNone">None</mat-checkbox>
        </div>
      </div>
    </div>

    <!--Emergency Services-->
    <div class="row" style="padding-top: 30px"></div>
    <mat-divider></mat-divider>

    <div class="row" style="padding-top: 30px">
      <div class="col-3">
        <mat-label><b>Emergency Services </b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_HealthInformation_EmergencyServices'"></help-text-btn>
        </mat-label>
      </div>
      <div class="col-3">
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="food">Food</mat-checkbox>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="housing">Housing</mat-checkbox>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="clothing">Clothing</mat-checkbox>
        </div>
        <div class="row">
          <mat-checkbox [color]="'primary'" formControlName="chkEmergencyOther">Other</mat-checkbox>
        </div>
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Comments</mat-label>
            <input matInput type="text" formControlName="txtEmergencyOther" (focusout)="updateChangeValueLostFocus()" />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" style="padding-top: 30px"></div>
  </form>

  <div clas="row" *ngIf="(action==2 || action==3) ">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Past Edit - {{this.trackHistories.inaHistory.length}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="this.trackHistories.inaHistory.length>=1">
          <app-past-edit [section]="this.section"></app-past-edit>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>


</mat-expansion-panel>